import { useState } from "react";

import { GiHamburgerMenu } from "react-icons/gi";
import NavigationBurguer from "../../components/NavigationBurguer";
import { Container } from "./styles";
const Header = () => {
  const [openNavBurguer, setOpenNavBurguer] = useState(false);

  return (
    <Container>
      <GiHamburgerMenu onClick={() => setOpenNavBurguer(true)} />
      {openNavBurguer && (
        <NavigationBurguer setOpenNavBurguer={setOpenNavBurguer} />
      )}
    </Container>
  );
};

export default Header;
